import React from "react";
import SuggestionCallout from "./SuggestionCallout";
import SpecSheetCard from "./SpecSheetCard";
import { formatCLP, formatCLPAbs } from "../utils/format";

const versionLabel = (v) => `${v.model_name} ${v.version_name}`.trim();

// Variante neutra del resultado: se usa cuando el ahorro no es positivo (el
// vehículo actual gasta menos que el Toyota). En vez de mostrar una pérdida en
// rojo, se habla de "diferencia de gasto" con un título y un mensaje genéricos,
// la sugerencia de comparar modelos equiparables y el detalle de ambos gastos.
const ResultNeutral = ({ version, result }) => (
    <div className="savings-calculator__result savings-calculator__result--neutral">
        <p className="savings-calculator__result-eyebrow">
            Diferencia de gasto en combustible
        </p>
        <p className="savings-calculator__result-figure">
            {formatCLPAbs(result.annual_savings_clp)}
            <span className="savings-calculator__result-per savings-calculator__result-per--inline">
                / año
            </span>
        </p>
        <p className="savings-calculator__result-message">
            Diferencia de gasto en combustible según el rendimiento, precio y
            kilometraje que ingresaste.
        </p>

        <SuggestionCallout />

        <p className="savings-calculator__result-detail">
            Gasto estimado de tu vehículo:{" "}
            <strong>{formatCLP(result.annual_cost_current_clp)}/año</strong> · Gasto{" "}
            {versionLabel(version)}:{" "}
            <strong>{formatCLP(result.annual_cost_toyota_clp)}/año</strong>
        </p>

        <SpecSheetCard url={version.spec_sheet_url} />
    </div>
);

export default ResultNeutral;
